/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SentQuotePostponeReason
 */
export interface SentQuotePostponeReason {
    /**
     * 
     * @type {boolean}
     * @memberof SentQuotePostponeReason
     */
    internalCompliance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SentQuotePostponeReason
     */
    externalCompliance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SentQuotePostponeReason
     */
    umbrellaRequest: boolean;
}

/**
 * Check if a given object implements the SentQuotePostponeReason interface.
 */
export function instanceOfSentQuotePostponeReason(value: object): value is SentQuotePostponeReason {
    if (!('internalCompliance' in value) || value['internalCompliance'] === undefined) return false;
    if (!('externalCompliance' in value) || value['externalCompliance'] === undefined) return false;
    if (!('umbrellaRequest' in value) || value['umbrellaRequest'] === undefined) return false;
    return true;
}

export function SentQuotePostponeReasonFromJSON(json: any): SentQuotePostponeReason {
    return SentQuotePostponeReasonFromJSONTyped(json, false);
}

export function SentQuotePostponeReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): SentQuotePostponeReason {
    if (json == null) {
        return json;
    }
    return {
        
        'internalCompliance': json['internalCompliance'],
        'externalCompliance': json['externalCompliance'],
        'umbrellaRequest': json['umbrellaRequest'],
    };
}

export function SentQuotePostponeReasonToJSON(value?: SentQuotePostponeReason | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'internalCompliance': value['internalCompliance'],
        'externalCompliance': value['externalCompliance'],
        'umbrellaRequest': value['umbrellaRequest'],
    };
}

